"use strict";

const { blank } = require ('printable-characters')

module.exports = (bullet, arg) => {

                    const isArray = Array.isArray (arg),
                          lines   = isArray ? arg : arg.split ('\n'),
                          indent  = blank (bullet),
                          result  = lines.map ((line, i) => (i === 0) ? (bullet + line) : (indent + line))
                    
                    return isArray ? result : result.join ('\n')
                }